import { render, staticRenderFns } from "./transfer-back.vue?vue&type=template&id=27fc251d&scoped=true&"
import script from "./transfer-back.vue?vue&type=script&lang=js&"
export * from "./transfer-back.vue?vue&type=script&lang=js&"
import style0 from "./transfer-back.vue?vue&type=style&index=0&id=27fc251d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fc251d",
  null
  
)

export default component.exports